import { useState, useEffect } from "react";

const API = process.env.REACT_APP_API_URL || "http://localhost:8000";

const GROUPES_DESC = {
  "Corps préfectoral 19e siècle": "Sous-préfets et conseillers de préfecture.",
  "Base Léonore": "Récipiendaires de la Légion d'honneur.",
};

const A_PROPOS = `
  
<div style="margin-bottom:20px;padding:10px 16px;background:#f5f5f5;border-radius:6px;font-size:13px">
  <strong>Sommaire</strong>
  <ul style="margin:6px 0 0;padding-left:18px">
    <li><a href="#fonctionnalites" style="color:#185FA5">Fonctionnalités</a></li>
    <li><a href="#mises-a-jour" style="color:#185FA5">Mises à jour</a></li>
    <li><a href="#sous-le-capot" style="color:#185FA5">Sous le capot</a></li>
    <li><a href="#mentions-legales" style="color:#185FA5">Mentions légales</a></li>
    <li><a href="#au-sujet-de-match-anf-data" style="color:#185FA5">Au sujet de Match ANF Data</a></li>
  </ul>
</div>

   <h2 id="fonctionnalites">Fonctionnalités</h2>

  <p>Tableau des données nominatives avec les champs suivants :</p>
  <ul>
  <li><b>Nom</b> : nom(s) de l'individu</li>
  <li><b>Prénom</b> : prénom(s) de l'individu</li>
  <li><b>Cote</b> : cote de l'unité documentaire aux Archives nationales</li>
  <li><b>ID</b> : identifiant unique sur le portail des Archives nationales (avec lien cliquable vers la notice descriptive)</li>
   <li><b>Genre</b> : genre, d'après les données des Archives nationales</li>
  <li><b>Date naissance</b> : format AAAA-MM-JJ ; si incomplet : AAAA-00-00</li>
  <li><b>Période (début / fin)</b> : période d'existence du corpus ou de l'individu, en années</li>
  <li><b>Groupe</b> : groupe thématique des données nominatives</li>
  <li><b>Wikidata</b> : le cas échéant, identifiant Wikidata</li>
  <li><b>Description</b> : description succincte voire liens</li>
  </ul>
<p><strong>Modes de recherche :</strong></p>
   <ul><li>Tris ascendant / descendant (clic sur les entêtes de colonnes)</li>
    <li>Recherche stricte</li>
    <li>Recherche floue (similarités de textes alphanumériques avec correspondances de trigrammes)</li>
    <li>Recherche par expressions régulières (exemples : "noms finissant par IAN = IAN$" ; "noms à consonnance portuguaise commençant par DA ou DOS = ^D[A|O][A-Z]{0,1} ([A-Z]{3,})"). Liste synthétique sur <a href="https://programminghistorian.org/fr/lecons/comprendre-les-expressions-regulieres#lid%C3%A9e-g%C3%A9n%C3%A9rale-des-expressions-r%C3%A9guli%C3%A8res" title="idée générale des expressions régulières - Programming Historian" target="_blank">Programming Historian</a></li>
    <li>Filtres par groupe, genre, période (années)</li>
    <li>Filtres additionnels cumulables : Prénom et Date de naissance, combinés avec la recherche principale</li></ul>

  <p><strong>Export CSV des résultats</strong> pour constituer des corpus de recherche</p>

  <p><strong>Appariement de fichiers CSV externes :</strong></p>
  <p>Import d'un fichier csv (maximum 1000 entrées) et recherche de correspondance(s) dans les groupes de données nominatives : combinaisons nom + prenom, nom + prenom + datenaissance ou nom + datenaissance.</p>
  
  <h2 id="mises-a-jour">Mises à jour</h2>
  <ul>
  <li><strong>Septembre 2026</strong> — Ajout du groupe Dossiers de police (Révolution et Premier Empire) : <a href="https://www.siv.archives-nationales.culture.gouv.fr/siv/IR/ FRAN_IR_062032" title="Inventaire Détenus de haute-police (Seine) (1791-1819) - sous-série F/7" target="_blank">détenus de haute-police (Seine)</a>, 
  <a href="https://www.siv.archives-nationales.culture.gouv.fr/siv/UD/FRAN_IR_000918/d_2_15_2" title="Inventaire Demandes et autorisations de résidence (1795-1801) - sous-série F/7" target="_blank">autorisations de résidence</a> 
  et <a href="https://www.siv.archives-nationales.culture.gouv.fr/siv/IR/FRAN_IR_056804" title="Inventaire Demandes de passeports (1793-1818) - sous-série F/7" target="_blank">demandes de passeports</a>.</li>
   <li><strong>Août 2026</strong> — Amélioration de la partie Explorer : ajout des champs cote, 
   période début et fin, Wikidata et id cliquable vers la notice descriptive AN en ligne ; ajout d'un 2e niveau de filtre (prenom, date) après une première recherche. Amélioration de l'appariement.</li>
   </li>

   <li><strong>Juin 2026</strong> — Ajout des premiers groupes de données : 
   <a target="_blank" href="https://www.data.gouv.fr/datasets/imprimeurs-libraires-et-lithographes-en-france-au-19e-siecle" title="Jeu de données Imprimeurs, libraires et lithographes 19e siècle sur data.gouv.fr">Imprimeurs, libraires et lithographes 19e siècle</a> ; 
   <a target="_blank" href="https://www.data.gouv.fr/datasets/pensions-et-secours-aux-combattants-et-victimes-des-revolutions-de-1789-1830-et-1848" title="Médailles et secours pour les combattants de 1789, 1830 et 1848 sur data.gouv.fr">Médailles et secours pour 1789, 1830 et 1848</a> ;
   <a target="_blank" href="https://www.leonore.archives-nationales.culture.gouv.fr/" "Base Léonore - récipiendaires de la Légion d'honneur">base Léonore (récipiendaires de la Légion d'honneur</a>) ;
   <a target="_blank" href="https://www.siv.archives-nationales.culture.gouv.fr/siv/IR/FRAN_IR_060073" title="Correspondance adressée au ministre de l'Intérieur 19e siècle - Archives nationales">Correspondance adressée au ministre de l'Intérieur 19e siècle</a> ;
   <a target="_blank" href="https://www.data.gouv.fr/datasets/individus-presumes-emigres-pendant-la-revolution-francaise-1791-1815" title="Présumés émigrés pendant la Révolution française - Archives nationales">Présumés émigrés pendant la Révolution française</a> ;
   <a target="_blank" href="https://www.data.gouv.fr/datasets/dossiers-nominatifs-du-fichier-central-de-la-surete-nationale-1870-1940" title="Fichier central de la Sûreté nationale 1870-1940 - Archives nationales">Fichier central de la Sûreté nationale 1870-1940</a> (genre ajouté à partir des prénoms) ; 
   inventaires du corps préfectoral ; <a target="_blank" href="https://rdf.archives-nationales.culture.gouv.fr/garance/" title="Notaires de Paris - GARANCE Archives nationales">notaires de Paris</a>

   </li>
    <li><strong>Mai 2026</strong> — Lancement de MatchANFdata en ligne</li>
  </ul>
  
  <h2 id="sous-le-capot">Sous le capot</h2>
  <p>Infrastructure : Docker + PostgreSQL + FastAPI + React + Caddy (code et 
  déploiement accompagné par Claude.AI, car bien que considérée comme geek
  dans ma sphère professionnelle, je n'ai pas les compétences pour déployer seule une app via Docker and Cie)</p>
  <p>Hébergement : VPS chez OVH (France) ; code sur <a target="_blank" href="https://framagit.org/patrimoine-et-numerique/matchanfdata">Framagit</a></p>
  <p>Statistiques de site avec cloud.umami.is</p>
  <p>Les groupes de données sont des données historiques ouvertes librement communicables diffusées par les 
  Archives nationales, restructurées avec <a target="_blank" href="https://openrefine.org">OpenRefine</a> avant d'être importées dans la base de données de Match ANF data.</p>
  
  <h2 id="mentions-legales">Mentions légales</h2>
  <p>Les données sont issues de sources historiques publiques librement accessibles.</p>
  <p>Logo : <a title="Julian Kücklich, CC0, via Wikimedia Commons" target="_blank" href="https://commons.wikimedia.org/wiki/File:Naturwissenschaften.png">Julian Kücklich, CC0, via Wikimedia Commons</a></p>
  <p>Les fichiers CSV importés pour l'appariement ne sont pas stockés après leur import.</p>
  <br/>
  <h2 id="au-sujet-de-match-anf-data">Au sujet de Match ANF Data</h2>
  <p>À force de brasser des données nominatives historiques, 
  à titre professionnel (aux Archives nationales) ou à titre privé (recherches historiques et
    généalogiques, enrichissement de données sur Wikidata), je rêvais depuis un moment d'un outil
    qui permettrait à la fois d'explorer des données volumineuses avec des modes de recherche floue, et 
    de les croiser facilement avec des ressources extérieures pour identifier des correspondances.
    Une sorte de <a target="_blank" href="https://deces.matchid.io" title="deces.matchid.io">deces.matchid.io</a> des 
    données nominatives historiques, pour faciliter la découverte et la constitution de corpus de données, et proposer 
    des croisements semi-automatiques sans rentrer dans des 
    manipulations de code.</p>
     <p>C'est ainsi qu'est né le prototype Match ANF Data.</p>
<p>Maïwenn Bourdic (<a target="_blank" href="https://patrimoine-et-numerique.fr" title="Patrimoine et numérique - boîte à outils et tutoriels
pour cultureux">Patrimoine et numérique</a>)</p>  
`;

// ─── Génération du lien vers la notice, selon le groupe ───────────────────────
function getIdUrl(idan, groupe) {
  if (!idan) return null;
  if (groupe === "Base Léonore (Légion d'honneur)") {
    return `https://www.leonore.archives-nationales.culture.gouv.fr/ui/notice/${encodeURI(idan)}`;
  }
  if (groupe === "Notaires de Paris") {
    return `https://www.siv.archives-nationales.culture.gouv.fr/siv/NP/${encodeURI(idan)}`;
  }
  return `https://www.siv.archives-nationales.culture.gouv.fr/siv/UD/${encodeURI(idan)}`;
}

// ─── Tooltip description ──────────────────────────────────────────────────────
function DescCell({ text }) {
  const [open, setOpen] = useState(false);
  if (!text) return <td style={{padding:"5px 8px"}} />;
  return (
    <td style={{padding:"5px 8px", maxWidth:280, position:"relative"}}>
      <span style={{display:"block", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap"}}>
        {text}
      </span>
      <span
        onClick={() => setOpen(o => !o)}
        style={{color:"#185FA5", cursor:"pointer", fontSize:11, userSelect:"none"}}
        title="Afficher la description complète"
      >
        {open ? "▲ réduire" : "▼ voir plus"}
      </span>
      {open && (
        <div style={{
          position:"absolute", zIndex:10, bottom:"100%", left:0,
          background:"#fff", border:"1px solid #ccc", borderRadius:6,
          padding:"10px 14px", maxWidth:420, boxShadow:"0 4px 16px rgba(0,0,0,.15)",
          fontSize:13, lineHeight:1.6, whiteSpace:"normal", wordBreak:"break-word"
        }}>
          {text}
        </div>
      )}
    </td>
  );
}

// ─── Tooltip "En savoir plus sur les champs" ──────────────────────────────────
function ChampsInfo() {
  const [open, setOpen] = useState(false);
  return (
    <span
      style={{position:"relative", display:"inline-block"}}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <span style={{color:"#185FA5", cursor:"pointer", fontSize:12,fontWeight:"bold", textDecoration:"underline", whiteSpace:"nowrap"}}>
        En savoir plus sur les champs
      </span>
      {open && (
        <div style={{
          position:"absolute", zIndex:20, top:"100%", right:0, marginTop:6,
          background:"#fff", border:"1px solid #ccc", borderRadius:6,
          padding:"12px 16px", width:380, boxShadow:"0 4px 16px rgba(0,0,0,.15)",
          fontSize:12.5, lineHeight:1.6, color:"#333", textAlign:"left"
        }}>
          <ul style={{margin:0, paddingLeft:18}}>
            <li><b>Nom</b> : nom(s) de l'individu</li>
            <li><b>Prénom</b> : prénom(s) de l'individu</li>
            <li><b>Cote</b> : cote de l'unité documentaire aux Archives nationales</li>
            <li><b>ID</b> : identifiant unique sur le portail des Archives nationales (lien cliquable vers la notice descriptive)</li>
            <li><b>Genre</b> : genre, d'après les données des Archives nationales</li>
            <li><b>Date naissance</b> : format AAAA-MM-JJ ; si incomplet : AAAA-00-00</li>
            <li><b>Période (début / fin)</b> : période d'existence du corpus ou de l'individu, en années</li>
            <li><b>Groupe</b> : groupe thématique des données nominatives</li>
            <li><b>Wikidata</b> : identifiant Wikidata le cas échéant (pour certains groupes uniquement, mises à jour régulières)</li>
            <li><b>Description</b> : complément d'information</li>
          </ul>
        </div>
      )}
    </span>
  );
}

// ─── Composant Explorer ───────────────────────────────────────────────────────
function Explorer({ groupes, totalBase, statsGroupe, onImportDone }) {
  const [query, setQuery] = useState("");
  const [champ, setChamp] = useState("tous");
  const [groupe, setGroupe] = useState("");
  const [genre, setGenre] = useState("");
  const [wikidataFiltre, setWikidataFiltre] = useState("");
  const [mode, setMode] = useState("strict");
  const [periodeMin, setPeriodeMin] = useState("");
  const [periodeMax, setPeriodeMax] = useState("");
  const [prenomExtra, setPrenomExtra] = useState("");
  const [ddnExtra, setDdnExtra] = useState("");
  const [results, setResults] = useState([]);
  const [totalResults, setTotalResults] = useState(null);
  const [page, setPage] = useState(1);
  const [limit] = useState(200);
  const [sortField, setSortField] = useState("nom");
  const [sortOrder, setSortOrder] = useState("asc");
  const [importing, setImporting] = useState(false);
  const [importMsg, setImportMsg] = useState(null);
  const [loading, setLoading] = useState(false);
  const [debouncedQuery, setDebouncedQuery] = useState("");
  const [debouncedPrenomExtra, setDebouncedPrenomExtra] = useState("");
  const [debouncedDdnExtra, setDebouncedDdnExtra] = useState("");

  useEffect(() => { const t = setTimeout(() => setDebouncedQuery(query), 350); return () => clearTimeout(t); }, [query]);
  useEffect(() => { const t = setTimeout(() => setDebouncedPrenomExtra(prenomExtra), 350); return () => clearTimeout(t); }, [prenomExtra]);
  useEffect(() => { const t = setTimeout(() => setDebouncedDdnExtra(ddnExtra), 350); return () => clearTimeout(t); }, [ddnExtra]);
  useEffect(() => { setPage(1); }, [debouncedQuery, champ, groupe, genre, mode, periodeMin, periodeMax, debouncedPrenomExtra, debouncedDdnExtra, wikidataFiltre]);

  useEffect(() => {
    const params = new URLSearchParams();
    if (debouncedQuery) params.append("q", debouncedQuery);
    params.append("champ", champ);
    if (groupe) params.append("groupe", groupe);
    if (genre) params.append("genre", genre);
    params.append("mode", mode);
    if (debouncedPrenomExtra) params.append("prenom_extra", debouncedPrenomExtra);
    if (debouncedDdnExtra) params.append("ddn_extra", debouncedDdnExtra);
    if (periodeMin) params.append("periode_min", periodeMin);
    if (periodeMax) params.append("periode_max", periodeMax);
    if (wikidataFiltre) params.append("wikidata_filtre", wikidataFiltre);
    params.append("limit", limit);
    params.append("offset", (page - 1) * limit);
    setLoading(true);
    fetch(`${API}/users?${params}`)
      .then(r => { if (!r.ok) throw new Error(); return r.json(); })
      .then(d => { setResults(Array.isArray(d.results) ? d.results : []); setTotalResults(d.total ?? null); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [debouncedQuery, champ, groupe, genre, mode, periodeMin, periodeMax, debouncedPrenomExtra, debouncedDdnExtra, wikidataFiltre, page, limit]);

  function uploadFile(e) {
    const file = e.target.files[0];
    if (!file) return;
    if (!file.name.endsWith(".csv")) { setImportMsg({ type: "err", text: "Le fichier doit être un .csv" }); return; }
    const fd = new FormData(); fd.append("file", file);
    setImporting(true); setImportMsg(null);
    fetch(`${API}/users/import`, { method: "POST", body: fd })
      .then(r => { if (!r.ok) return r.json().then(e => { throw new Error(e.detail); }); return r.json(); })
      .then(d => { setImportMsg({ type: "ok", text: `✓ ${d.inserted} lignes importées depuis ${d.filename}` }); onImportDone(); })
      .catch(err => setImportMsg({ type: "err", text: `Erreur : ${err.message}` }))
      .finally(() => { setImporting(false); e.target.value = ""; });
  }

  const sorted = [...results].sort((a, b) => {
    const vA = (a[sortField] || "").toString().toLowerCase(), vB = (b[sortField] || "").toString().toLowerCase();
    return sortOrder === "asc" ? (vA > vB ? 1 : -1) : (vA < vB ? 1 : -1);
  });

  function toggleSort(f) {
    if (sortField === f) setSortOrder(o => o === "asc" ? "desc" : "asc");
    else { setSortField(f); setSortOrder("asc"); }
  }

  const totalPages = totalResults !== null ? Math.ceil(totalResults / limit) : 1;

  function exportCSV() {
    const params = new URLSearchParams();
    params.append("q", debouncedQuery);
    params.append("champ", champ);
    if (groupe) params.append("groupe", groupe);
    if (genre) params.append("genre", genre);
    params.append("mode", mode);
    if (debouncedPrenomExtra) params.append("prenom_extra", debouncedPrenomExtra);
    if (debouncedDdnExtra) params.append("ddn_extra", debouncedDdnExtra);
    if (periodeMin) params.append("periode_min", periodeMin);
    if (periodeMax) params.append("periode_max", periodeMax);
    if (wikidataFiltre) params.append("wikidata_filtre", wikidataFiltre);
    window.location.href = `${API}/users/export?${params}`;
  }

  const columns = [
    {key:"nom",    label:"Nom"},
    {key:"prenom", label:"Prénom"},
    {key:"cote",   label:"Cote"},
    {key:"idan",   label:"ID"},
    {key:"genre",  label:"Genre"},
    {key:"datenaissance", label:"Date naissance"},
    {key:"periode_debut", label:"Période (début)"},
    {key:"periode_fin",   label:"Période (fin)"},
    {key:"groupe", label:"Groupe"},
    {key:"wikidata", label:"Wikidata"},
    {key:"description", label:"Description"},
  ];

  return (
    <>
      <div style={{display:"flex",gap:12,marginBottom:16,flexWrap:"wrap"}}>
        <div style={{background:"#f0f4ff",borderRadius:6,padding:"8px 16px",fontSize:13}}>
          <strong>{totalBase !== null ? totalBase.toLocaleString("fr-FR") : "…"}</strong> enregistrements en base
        </div>
        {statsGroupe.map(g => (
          <div key={g.groupe} style={{background:"#f5f5f5",borderRadius:6,padding:"8px 16px",fontSize:13}}>
            <strong>{Number(g.n).toLocaleString("fr-FR")}</strong> — {g.groupe}
            {GROUPES_DESC[g.groupe] && <div style={{fontSize:11,color:"#666",marginTop:2,maxWidth:200}}>{GROUPES_DESC[g.groupe]}</div>}
          </div>
        ))}
      </div>

      {/* ── Texte introductif ── */}
      <div style={{marginBottom:16,padding:"10px 16px",background:"#fffbf0",borderLeft:"3px solid #e0a800",borderRadius:4,fontSize:13,lineHeight:1.6,color:"#444"}}>
        <img 
    src="https://commons.wikimedia.org/wiki/Special:FilePath/Naturwissenschaften.png" 
    alt="Naturwissenschaften" 
    style={{float:"right", width:180, marginLeft:12, marginBottom:8}}
  />
        <strong>Match ANF data</strong> est un outil prototype qui permet d'explorer des données nominatives 
        historiques. Les corpus proposés sont issus de données librement communicables, 
        diffusables et réutilisables des <a href="https://www.archives-nationales.culture.gouv.fr/ouverture-des-donnees-des-archives-nationales" title="Archives nationales - Ouverture des données" target="_blank">Archives nationales (France)</a>.
        <br/>L'onglet <b>Explorer</b> propose différents modes de recherche : recherche stricte (correspondance exacte), 
        recherche floue (variantes orthographiques) ou expressions régulières ("regex", voir des exemples dans "À propos"), 
        sur tous les champs, ou uniquement "Nom", "Prénom", "Date de naissance" ; des possibilités de filtre par genre ou par corpus ; 
        des filtres additionnels cumulables (Prénom, Date de naissance) ; un export (CSV)
        des résultats d'une recherche.
        <br/>
        L'onglet <b>Appariement</b> permet de croiser un fichier CSV externe avec les données de Match ANF data (toutes les données, ou uniquement un corpus).
      </div>

      
      <div style={{display:"flex",gap:8,marginBottom:10,flexWrap:"wrap",alignItems:"center"}}>
        <input placeholder="Recherche…" value={query} onChange={e=>setQuery(e.target.value)} style={{flex:1,minWidth:180,padding:"6px 8px"}}/>
        <select value={champ} onChange={e=>setChamp(e.target.value)} style={{padding:"6px 8px"}}>
          <option value="tous">Tous les champs</option>
          <option value="nom">Nom uniquement</option>
          <option value="prenom">Prénom uniquement</option>
          <option value="datenaissance">Date de naissance</option>
        </select>
        <select value={mode} onChange={e=>setMode(e.target.value)} style={{padding:"6px 8px"}}>
          <option value="strict">Strict</option>
          <option value="fuzzy">Flou (pg_trgm)</option>
          <option value="regex">Regex</option>
        </select>
               <select value={genre} onChange={e=>setGenre(e.target.value)} style={{padding:"6px 8px"}}>
          <option value="">Tous genres</option>
          <option value="homme">Homme</option>
          <option value="femme">Femme</option>
          <option value="n/a">N/A</option>
        </select>
        <input type="number" placeholder="Année min" value={periodeMin} onChange={e=>setPeriodeMin(e.target.value)} style={{width:100,padding:"6px 8px"}}/>
        <input type="number" placeholder="Année max" value={periodeMax} onChange={e=>setPeriodeMax(e.target.value)} style={{width:100,padding:"6px 8px"}}/>
        <select value={groupe} onChange={e=>setGroupe(e.target.value)} style={{padding:"6px 8px"}}>
          <option value="">Tous groupes</option>
          {groupes.map(g=><option key={g} value={g}>{g}</option>)}
        </select>
        <select value={wikidataFiltre} onChange={e=>setWikidataFiltre(e.target.value)} style={{padding:"6px 8px"}}>
          <option value="">Wikidata : tous</option>
          <option value="oui">Wikidata : avec</option>
          <option value="non">Wikidata : sans</option>
        </select>
        <button onClick={exportCSV} style={{padding:"6px 12px"}}>Export CSV</button>
      </div>

      {/* ── Filtres additionnels cumulables (utilisent le même mode Strict/Flou/Regex ci-dessus) ── */}
      <div style={{display:"flex",gap:8,marginBottom:10,flexWrap:"wrap",alignItems:"center"}}>
        <span style={{fontSize:12,color:"#888"}}>+ Filtres additionnels (combinés à la recherche principale) :</span>
        <input placeholder="Filtrer par prénom…" value={prenomExtra} onChange={e=>setPrenomExtra(e.target.value)} style={{padding:"6px 8px",minWidth:160}}/>
        <input placeholder="Filtrer par date de naissance…" value={ddnExtra} onChange={e=>setDdnExtra(e.target.value)} style={{padding:"6px 8px",minWidth:200}}/>
      </div>

      <div style={{fontSize:13,color:"#555",marginBottom:8,minHeight:20,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
  <span>
    {loading ? "Recherche en cours…" : totalResults !== null ? (
      <><strong>{totalResults.toLocaleString("fr-FR")}</strong> résultat{totalResults!==1?"s":""}
      {totalResults > limit && <span style={{color:"#c00",marginLeft:6}}>— page {page}/{totalPages}</span>}</>
    ) : ""}
  </span>
  <ChampsInfo/>
</div>

      <div style={{overflowX:"auto"}}>
        <table border="1" width="100%" style={{borderCollapse:"collapse",fontSize:13}}>
          <thead>
            <tr style={{background:"#f5f5f5"}}>
              {columns.map(col=>(
                <th key={col.key} onClick={()=>toggleSort(col.key)} style={{cursor:"pointer",padding:"6px 8px",textAlign:"left",whiteSpace:"nowrap"}}>
                  {col.label}{sortField===col.key?(sortOrder==="asc"?" ▲":" ▼"):""}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {sorted.length===0 ? (
              <tr><td colSpan={columns.length} style={{textAlign:"center",padding:20,color:"#999"}}>
                {query?"Aucun résultat":"Lancez une recherche ou importez un CSV"}
              </td></tr>
            ) : sorted.map(u=>(
              <tr key={u.id}>
                <td style={{padding:"5px 8px",fontWeight:500}}>{u.nom}</td>
                <td style={{padding:"5px 8px"}}>{u.prenom}</td>
                <td style={{padding:"5px 8px"}}>{u.cote}</td>
                <td style={{padding:"5px 8px",color:"#888",fontSize:11}}>
                  {u.idan ? (
                    <a href={getIdUrl(u.idan, u.groupe)} target="_blank" rel="noreferrer" style={{color:"#185FA5"}}>
                      {u.idan}
                    </a>
                  ) : ""}
                </td>
                <td style={{padding:"5px 8px"}}>{u.genre}</td>
                <td style={{padding:"5px 8px",whiteSpace:"nowrap"}}>{u.datenaissance}</td>
                <td style={{padding:"5px 8px"}}>{u.periode_debut}</td>
                <td style={{padding:"5px 8px"}}>{u.periode_fin}</td>
                <td style={{padding:"5px 8px"}}>{u.groupe}</td>
                <td style={{padding:"5px 8px"}}>
                {u.wikidata ? (
                <a href={`https://www.wikidata.org/wiki/${encodeURI(u.wikidata)}`} target="_blank" rel="noreferrer" style={{color:"#185FA5"}}>
                {u.wikidata}
                </a>
                ) : ""}
                </td>
                <DescCell text={u.description} />
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {totalPages > 1 && (
        <div style={{marginTop:8,display:"flex",alignItems:"center",gap:8}}>
          <button disabled={page===1} onClick={()=>setPage(p=>p-1)}>← Préc.</button>
          <span>Page {page} / {totalPages}</span>
          <button disabled={page>=totalPages} onClick={()=>setPage(p=>p+1)}>Suiv. →</button>
        </div>
      )}
    </>
  );
}

// ─── Composant Appariement ────────────────────────────────────────────────────
function Appariement({ groupes }) {
  const [file, setFile] = useState(null);
  const [modeMatch, setModeMatch] = useState("nom_prenom");
  const [groupeCible, setGroupeCible] = useState("");
  const [seuil, setSeuil] = useState(70);
  const [topK] = useState(3);
  const [running, setRunning] = useState(false);
  const [stats, setStats] = useState(null);
  const [erreur, setErreur] = useState(null);
  const [downloadUrl, setDownloadUrl] = useState(null);

  function lancer() {
    if (!file) { setErreur("Veuillez sélectionner un fichier CSV."); return; }
    setRunning(true); setStats(null); setErreur(null); setDownloadUrl(null);
    const fd = new FormData();
    fd.append("file", file);
    const params = new URLSearchParams({
      mode: modeMatch,
      groupe_cible: groupeCible,
      seuil: (seuil / 100).toFixed(2),
      top_k: topK,
    });
    fetch(`${API}/match?${params}`, { method: "POST", body: fd })
      .then(res => {
        if (!res.ok) return res.json().then(e => { throw new Error(e.detail || `Erreur HTTP ${res.status}`); });
        const total = parseInt(res.headers.get("X-Total-Source") || "0");
        const apparies = parseInt(res.headers.get("X-Total-Apparies") || "0");
        const nonTrouves = parseInt(res.headers.get("X-Total-Non-Trouves") || "0");
        setStats({ total, apparies, nonTrouves });
        return res.blob();
      })
      .then(blob => { const url = URL.createObjectURL(blob); setDownloadUrl(url); })
      .catch(err => setErreur(err.message))
      .finally(() => setRunning(false));
  }

  const seuilColor = seuil >= 80 ? "#137333" : seuil >= 60 ? "#854F0B" : "#c62828";

  return (
    <div style={{maxWidth:700}}>
      <h3 style={{marginBottom:16}}>Appariement de fichier CSV</h3>

      <div style={{marginBottom:14}}>
        <label style={{fontWeight:500,display:"block",marginBottom:6}}>Fichier CSV à apparier (max 1000 lignes) :</label>
        <label style={{
          display:"inline-block",padding:"6px 14px",background:"#eee",border:"1px solid #ccc",
          borderRadius:4,cursor:"pointer",fontSize:13
        }}>
          Choisir un fichier
          <input
            type="file"
            accept=".csv"
            onChange={e => { setFile(e.target.files[0]); setStats(null); setDownloadUrl(null); setErreur(null); }}
            style={{display:"none"}}
          />
        </label>
        <span style={{marginLeft:10,fontSize:13,color:"#555"}}>
          {file ? file.name : "Aucun fichier sélectionné"}
        </span>
      </div>

      <h4 style={{margin:"18px 0 8px",fontSize:16}}>Colonnes attendues dans le CSV : nom, prenom, datenaissance</h4>
      <div style={{background:"#f5f5f5",borderRadius:6,padding:"10px 14px",fontSize:12,color:"#555",marginBottom:16}}>
        Séparateur détecté automatiquement (virgule, point-virgule ou tabulation).<br/>
        La date de naissance peut être une date complète (AAAA-MM-JJ) ou une année seule (ex. 1850).<br/>
        <br/>Top {topK} meilleures correspondances par ligne.
      </div>

      <h4 style={{margin:"18px 0 8px"}}>Mode d'appariement</h4>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:14}}>
        <div>
          <label style={{fontWeight:500,display:"block",marginBottom:4,fontSize:13}}>Champs</label>
          <select value={modeMatch} onChange={e=>setModeMatch(e.target.value)} style={{width:"100%",padding:"6px 8px"}}>
            <option value="nom_prenom">Nom + Prénom</option>
            <option value="nom_prenom_ddn">Nom + Prénom + Date de naissance</option>
            <option value="nom_ddn">Nom + Date de naissance</option>
          </select>
        </div>
        <div>
          <label style={{fontWeight:500,display:"block",marginBottom:4,fontSize:13}}>Groupe cible</label>
          <select value={groupeCible} onChange={e=>setGroupeCible(e.target.value)} style={{width:"100%",padding:"6px 8px"}}>
            <option value="">Toute la base</option>
            {groupes.map(g=><option key={g} value={g}>{g}</option>)}
          </select>
        </div>
      </div>

      <div style={{marginBottom:16}}>
        <label style={{fontWeight:500,display:"block",marginBottom:6,fontSize:16}}>
          Seuil de similarité minimum : <span style={{color:seuilColor,fontWeight:700}}>{seuil}%</span>
        </label>
        <input type="range" min={30} max={95} step={5} value={seuil} onChange={e=>setSeuil(Number(e.target.value))} style={{width:"100%"}}/>
        <div style={{display:"flex",justifyContent:"space-between",fontSize:11,color:"#888"}}>
          <span>30% — large</span><span>70% — équilibré</span><span>95% — strict</span>
        </div>
      </div>

      <button
        onClick={lancer}
        disabled={running || !file}
        style={{padding:"8px 20px",background:running?"#aaa":"#185FA5",color:"#fff",border:"none",borderRadius:4,cursor:running?"not-allowed":"pointer",fontSize:14}}
      >
        {running ? "Appariement en cours…" : "Lancer l'appariement"}
      </button>
      {erreur && (
        <div style={{marginTop:14,padding:"8px 12px",background:"#fce8e6",color:"#c62828",borderRadius:4,fontSize:13}}>
          ✗ {erreur}
        </div>
      )}
      {stats && (
        <div style={{marginTop:16}}>
          <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:10,marginBottom:12}}>
            <div style={{background:"#f0f4ff",borderRadius:6,padding:"10px 14px",textAlign:"center"}}>
              <div style={{fontSize:22,fontWeight:700}}>{stats.total}</div>
              <div style={{fontSize:12,color:"#555"}}>Lignes source</div>
            </div>
            <div style={{background:"#e6f4ea",borderRadius:6,padding:"10px 14px",textAlign:"center"}}>
              <div style={{fontSize:22,fontWeight:700,color:"#137333"}}>{stats.apparies}</div>
              <div style={{fontSize:12,color:"#555"}}>Appariées</div>
            </div>
            <div style={{background:"#fce8e6",borderRadius:6,padding:"10px 14px",textAlign:"center"}}>
              <div style={{fontSize:22,fontWeight:700,color:"#c62828"}}>{stats.nonTrouves}</div>
              <div style={{fontSize:12,color:"#555"}}>Non trouvées</div>
            </div>
          </div>
          {downloadUrl && (
            <a href={downloadUrl} download="appariement_resultat.csv"
              style={{display:"inline-block",padding:"8px 20px",background:"#1D9E75",color:"#fff",borderRadius:4,textDecoration:"none",fontSize:14}}>
              ⬇ Télécharger le résultat CSV
            </a>
          )}
        </div>
      )}
    </div>
  );
}



// ─── App principale ───────────────────────────────────────────────────────────
function App() {
  const [page_app, setPageApp] = useState("explorer");
  const [groupes, setGroupes] = useState([]);
  const [totalBase, setTotalBase] = useState(null);
  const [statsGroupe, setStatsGroupe] = useState([]);

  function loadStats() {
    fetch(`${API}/groupes`).then(r=>r.json()).then(d=>setGroupes(Array.isArray(d)?d:[]));
    fetch(`${API}/stats`).then(r=>r.json()).then(d=>{setTotalBase(d.total);setStatsGroupe(d.par_groupe||[]);});
  }

  useEffect(()=>{ loadStats(); }, []);

  const navStyle = (p) => ({
    padding:"8px 16px",cursor:"pointer",border:"none",background:"none",
    fontWeight:page_app===p?"b":"normal",
    borderBottom:page_app===p?"2px solid #333":"2px solid transparent",
    fontSize:14,
  });

  return (
    <div style={{fontFamily:"sans-serif",maxWidth:1400,margin:"0 auto",padding:20}}>
      <div style={{display:"flex",alignItems:"center",borderBottom:"1px solid #ddd",marginBottom:20}}>
        <h1 style={{fontSize:18,margin:"0 24px 0 0"}}>Match ANF Data</h1>
        <button style={navStyle("explorer")} onClick={()=>setPageApp("explorer")}>Explorer</button>
        <button style={navStyle("appariement")} onClick={()=>setPageApp("appariement")}>Appariement</button>
        <button style={navStyle("apropos")} onClick={()=>setPageApp("apropos")}>À propos</button>
      </div>

      {page_app==="explorer" && <Explorer groupes={groupes} totalBase={totalBase} statsGroupe={statsGroupe} onImportDone={loadStats}/>}
      {page_app==="appariement" && <Appariement groupes={groupes}/>}
      {page_app==="apropos" && <div style={{maxWidth:700,lineHeight:1.7}} dangerouslySetInnerHTML={{__html:A_PROPOS}}/>}
    </div>
  );
}

export default App;